export enum SchedulePublicHolidayType {
  FEDERAL = "federal",
  LANDWEIL = "landweil"
}

export type SchedulePublicHolidays = {
  names: { en: string; de: string };
  date: string; // iso string
  type: SchedulePublicHolidayType;
  states: string[];
};

export const BASE_HOLIDAYS_ATTRIBUTES = {
  NEW_YEARS_DAY: {
    type: SchedulePublicHolidayType.FEDERAL,
    states: ["All states"],
    names: { en: "New Year's Day", de: "Neujahrstag" }
  },
  EPIPHANY: {
    type: SchedulePublicHolidayType.LANDWEIL,
    states: ["Baden-Württemberg", "Bavaria", "Saxony-Anhalt"],
    names: { en: "Epiphany", de: "Heilige Drei Könige" }
  },
  INTERNATIONAL_WOMENS_DAY: {
    type: SchedulePublicHolidayType.LANDWEIL,
    states: ["Berlin", "Mecklenburg-Vorpommern"],
    names: { en: "International Women's Day", de: "Internationaler Frauentag" }
  },
  GOOD_FRIDAY: {
    type: SchedulePublicHolidayType.FEDERAL,
    states: ["All states"],
    names: { en: "Good Friday", de: "Karfreitag" }
  },
  EASTER_MONDAY: {
    type: SchedulePublicHolidayType.FEDERAL,
    states: ["All states"],
    names: { en: "Easter Monday", de: "Ostermontag" }
  },
  LABOUR_DAY: {
    type: SchedulePublicHolidayType.FEDERAL,
    states: ["All states"],
    names: { en: "Labour Day", de: "Tag der Arbeit" }
  },
  ASCENSION_DAY: {
    type: SchedulePublicHolidayType.FEDERAL,
    states: ["All states"],
    names: { en: "Ascension Day", de: "Christi Himmelfahrt" }
  },
  WHIT_MONDAY: {
    type: SchedulePublicHolidayType.FEDERAL,
    states: ["All states"],
    names: { en: "Whit Monday/Pentecost Monday", de: "Pfingstmontag" }
  },
  CORPUS_CHRISTI: {
    type: SchedulePublicHolidayType.LANDWEIL,
    states: [
      "Baden-Württemberg",
      "Bavaria",
      "Hesse",
      "North Rhine-Westphalia",
      "Rhineland-Palatinate",
      "Saarland",
      "Saxony(parts of)",
      "Thuringia(parts of)"
    ],
    names: { en: "Corpus Christi", de: "Fronleichnam" }
  },
  ASSUMPTION_DAY: {
    type: SchedulePublicHolidayType.LANDWEIL,
    states: ["Saarland", "Bavaria(in municipalities with a predominantly Catholic population)"],
    names: { en: "Assumption Day", de: "Mariä Himmelfahrt" }
  },
  GERMAN_UNITY_DAY: {
    type: SchedulePublicHolidayType.FEDERAL,
    states: ["All states"],
    names: { en: "German Unity Day", de: "Tag der Deutschen Einheit" }
  },
  REFORMATION_DAY: {
    type: SchedulePublicHolidayType.LANDWEIL,
    states: [
      "Brandenburg",
      "Bremen",
      "Hamburg",
      "Mecklenburg-Vorpommern",
      "Lower Saxony",
      "Saxony",
      "Saxony-Anhalt",
      "Schleswig-Holstein",
      "Thuringia"
    ],
    names: { en: "Reformation Day", de: "Reformationstag" }
  },
  ALL_SAINTS_DAY: {
    type: SchedulePublicHolidayType.LANDWEIL,
    states: [
      "Baden-Württemberg",
      "Bavaria",
      "North Rhine-Westphalia",
      "Rhineland-Palatinate",
      "Saarland"
    ],
    names: { en: "All Saints' Day", de: "Allerheiligen" }
  },
  REPENTANCE_AND_PRAYER_DAY: {
    type: SchedulePublicHolidayType.LANDWEIL,
    states: ["Saxony"],
    names: { en: "Repentance and Prayer Day", de: "Buß- und Bettag" }
  },
  CHRISTMAS_DAY: {
    type: SchedulePublicHolidayType.FEDERAL,
    states: ["All states"],
    names: { en: "Christmas Day", de: "Erster Weihnachtsfeiertag" }
  },
  SECOND_DAY_OF_CHRISTMAS: {
    type: SchedulePublicHolidayType.FEDERAL,
    states: ["All states"],
    names: { en: "Second Day of Christmas", de: "Zweiter Weihnachtsfeiertag" }
  }
};

export const holidays2025: SchedulePublicHolidays[] = [
  { ...BASE_HOLIDAYS_ATTRIBUTES.SECOND_DAY_OF_CHRISTMAS, date: "2025-12-26" },
  { ...BASE_HOLIDAYS_ATTRIBUTES.CHRISTMAS_DAY, date: "2025-12-25" },
  { ...BASE_HOLIDAYS_ATTRIBUTES.REPENTANCE_AND_PRAYER_DAY, date: "2025-11-19" },
  { ...BASE_HOLIDAYS_ATTRIBUTES.ALL_SAINTS_DAY, date: "2025-11-01" },
  { ...BASE_HOLIDAYS_ATTRIBUTES.REFORMATION_DAY, date: "2025-10-31" },
  { ...BASE_HOLIDAYS_ATTRIBUTES.GERMAN_UNITY_DAY, date: "2025-10-03" },
  { ...BASE_HOLIDAYS_ATTRIBUTES.ASSUMPTION_DAY, date: "2025-08-15" },
  { ...BASE_HOLIDAYS_ATTRIBUTES.CORPUS_CHRISTI, date: "2025-06-19" },
  { ...BASE_HOLIDAYS_ATTRIBUTES.WHIT_MONDAY, date: "2025-06-09" },
  { ...BASE_HOLIDAYS_ATTRIBUTES.ASCENSION_DAY, date: "2025-05-29" },
  { ...BASE_HOLIDAYS_ATTRIBUTES.LABOUR_DAY, date: "2025-05-01" },
  { ...BASE_HOLIDAYS_ATTRIBUTES.EASTER_MONDAY, date: "2025-04-21" },
  { ...BASE_HOLIDAYS_ATTRIBUTES.GOOD_FRIDAY, date: "2025-04-18" },
  { ...BASE_HOLIDAYS_ATTRIBUTES.INTERNATIONAL_WOMENS_DAY, date: "2025-03-08" },
  { ...BASE_HOLIDAYS_ATTRIBUTES.EPIPHANY, date: "2025-01-06" },
  { ...BASE_HOLIDAYS_ATTRIBUTES.NEW_YEARS_DAY, date: "2025-01-01" }
];

export const holidays2026: SchedulePublicHolidays[] = [
  { ...BASE_HOLIDAYS_ATTRIBUTES.REFORMATION_DAY, date: "2026-10-31" },
  { ...BASE_HOLIDAYS_ATTRIBUTES.ALL_SAINTS_DAY, date: "2026-11-01" },
  { ...BASE_HOLIDAYS_ATTRIBUTES.REPENTANCE_AND_PRAYER_DAY, date: "2026-11-18" },
  { ...BASE_HOLIDAYS_ATTRIBUTES.CHRISTMAS_DAY, date: "2026-12-25" },
  { ...BASE_HOLIDAYS_ATTRIBUTES.SECOND_DAY_OF_CHRISTMAS, date: "2026-12-26" },
  { ...BASE_HOLIDAYS_ATTRIBUTES.GOOD_FRIDAY, date: "2026-04-03" },
  { ...BASE_HOLIDAYS_ATTRIBUTES.EASTER_MONDAY, date: "2026-04-06" },
  { ...BASE_HOLIDAYS_ATTRIBUTES.LABOUR_DAY, date: "2026-05-01" },
  { ...BASE_HOLIDAYS_ATTRIBUTES.ASCENSION_DAY, date: "2026-05-14" },
  { ...BASE_HOLIDAYS_ATTRIBUTES.WHIT_MONDAY, date: "2026-05-25" },
  { ...BASE_HOLIDAYS_ATTRIBUTES.CORPUS_CHRISTI, date: "2026-06-04" },
  { ...BASE_HOLIDAYS_ATTRIBUTES.ASSUMPTION_DAY, date: "2026-08-15" },
  { ...BASE_HOLIDAYS_ATTRIBUTES.GERMAN_UNITY_DAY, date: "2026-10-03" },
  { ...BASE_HOLIDAYS_ATTRIBUTES.NEW_YEARS_DAY, date: "2026-01-01" },
  { ...BASE_HOLIDAYS_ATTRIBUTES.EPIPHANY, date: "2026-01-06" },
  { ...BASE_HOLIDAYS_ATTRIBUTES.INTERNATIONAL_WOMENS_DAY, date: "2026-03-08" }
];

export const holidays2027: SchedulePublicHolidays[] = [
  { ...BASE_HOLIDAYS_ATTRIBUTES.NEW_YEARS_DAY, date: "2027-01-01" },
  { ...BASE_HOLIDAYS_ATTRIBUTES.EPIPHANY, date: "2027-01-06" },
  { ...BASE_HOLIDAYS_ATTRIBUTES.INTERNATIONAL_WOMENS_DAY, date: "2027-03-08" },
  { ...BASE_HOLIDAYS_ATTRIBUTES.GOOD_FRIDAY, date: "2027-03-26" },
  { ...BASE_HOLIDAYS_ATTRIBUTES.EASTER_MONDAY, date: "2027-03-29" },
  { ...BASE_HOLIDAYS_ATTRIBUTES.LABOUR_DAY, date: "2027-05-01" },
  { ...BASE_HOLIDAYS_ATTRIBUTES.ASCENSION_DAY, date: "2027-05-06" },
  { ...BASE_HOLIDAYS_ATTRIBUTES.WHIT_MONDAY, date: "2027-05-17" },
  { ...BASE_HOLIDAYS_ATTRIBUTES.CORPUS_CHRISTI, date: "2027-05-27" },
  { ...BASE_HOLIDAYS_ATTRIBUTES.ASSUMPTION_DAY, date: "2027-08-15" },
  { ...BASE_HOLIDAYS_ATTRIBUTES.GERMAN_UNITY_DAY, date: "2027-10-03" },
  { ...BASE_HOLIDAYS_ATTRIBUTES.REFORMATION_DAY, date: "2027-10-31" },
  { ...BASE_HOLIDAYS_ATTRIBUTES.ALL_SAINTS_DAY, date: "2027-11-01" },
  { ...BASE_HOLIDAYS_ATTRIBUTES.REPENTANCE_AND_PRAYER_DAY, date: "2027-11-17" },
  { ...BASE_HOLIDAYS_ATTRIBUTES.CHRISTMAS_DAY, date: "2027-12-25" },
  { ...BASE_HOLIDAYS_ATTRIBUTES.SECOND_DAY_OF_CHRISTMAS, date: "2027-12-26" }
];
